// Per-form accumulated file list (survives multiple open-dialog clicks)
const formFilesMap = new WeakMap();

function getFiles(formEl) {
  return formFilesMap.get(formEl) || [];
}

function setFiles(formEl, files) {
  formFilesMap.set(formEl, files);
}

// Clear files + UI for a given form (jQuery or DOM element)
window.clearPropertyNoteFiles = function(form) {
  const formEl = form instanceof jQuery ? form[0] : form;
  if (!formEl) return;
  setFiles(formEl, []);
  const $form = $(formEl);
  $form.find('.property-note-upload-preview').html('');
  $form.find('.property-note-upload-status').hide();
  const fileInput = formEl.querySelector('input[type="file"]');
  if (fileInput) fileInput.value = '';
  $form.find('.property-note-file-upload-label span').text('Click to select images');
  $form.find('.property-note-file-upload-label small').text('or drag and drop');
};

// Re-render the preview grid for a form from its accumulated file list
function renderPreview(form, files) {
  const $preview = form.find('.property-note-upload-preview');
  $preview.html('');

  files.forEach((file, index) => {
    const reader = new FileReader();
    reader.onload = function(ev) {
      const $item = $(`
        <div class="preview-item" style="position:relative;margin:5px;display:inline-block;vertical-align:top;">
          <img src="${ev.target.result}"
               style="max-width:100px;max-height:100px;display:block;margin-bottom:4px;border-radius:4px;">
          <button type="button"
                  class="btn btn-danger btn-sm remove-preview-image"
                  data-index="${index}"
                  style="position:absolute;top:2px;right:2px;padding:1px 5px;font-size:11px;line-height:1.4;"
                  title="Remove">&#x2715;</button>
          <div class="progress" style="height:4px;">
            <div class="progress-bar" role="progressbar" style="width:0%"></div>
          </div>
        </div>
      `);
      $preview.append($item);
    };
    reader.readAsDataURL(file);
  });

  const count = files.length;
  form.find('.property-note-file-upload-label span')
      .text(count > 0 ? `${count} ${count === 1 ? 'file' : 'files'} selected` : 'Click to select images');
  form.find('.property-note-file-upload-label small')
      .text(count > 0 ? 'Click to add more' : 'or drag and drop');
}

// Image compression
async function compressImage(file) {
  const maxSizeInBytes = 1 * 1024 * 1024;
  const maxWidth = 1200;
  const maxHeight = 1200;
  const quality = 0.9;

  if (file.size <= maxSizeInBytes) return file;

  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function(e) {
      const img = new Image();
      img.src = e.target.result;
      img.onload = function() {
        let width = img.width;
        let height = img.height;
        if (width > height && width > maxWidth) {
          height = Math.round((height * maxWidth) / width);
          width = maxWidth;
        } else if (height > maxHeight) {
          width = Math.round((width * maxHeight) / height);
          height = maxHeight;
        }
        const canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        canvas.getContext('2d').drawImage(img, 0, 0, width, height);
        canvas.toBlob((blob) => {
          resolve(new File([blob], file.name, { type: 'image/jpeg', lastModified: Date.now() }));
        }, 'image/jpeg', quality);
      };
    };
  });
}

// Submit handler — reads accumulated files from WeakMap
window.handlePropertyNoteSubmit = async function(event, button) {
  event.preventDefault();
  const form = $(button).closest('.property-note-form');
  if (!form.length) return;

  const formEl = form[0];
  const files = getFiles(formEl);
  const uploadStatus = form.find('.property-note-upload-status');
  const uploadPreview = form.find('.property-note-upload-preview');
  const btn = $(button);

  btn.prop('disabled', true).text('Submitting...');
  uploadStatus.css('display', 'block').attr('class', 'alert alert-info').text('Preparing to upload...');

  try {
    let uploadedImages = [];

    if (files.length > 0) {
      uploadStatus.text('Compressing and uploading images...');

      const compressedFiles = await Promise.all(
        files.map(async (file) => {
          uploadStatus.text(`Compressing ${file.name}...`);
          return await compressImage(file);
        })
      );

      for (let i = 0; i < compressedFiles.length; i++) {
        const file = compressedFiles[i];
        const fd = new FormData();
        fd.append('file', file);
        fd.append('upload_preset', 'direct_upload_preset');
        fd.append('folder', 'property_note_images');

        uploadStatus.text(`Uploading image ${i + 1} of ${compressedFiles.length}...`);

        try {
          const response = await fetch('https://api.cloudinary.com/v1_1/reactappp/image/upload', {
            method: 'POST',
            body: fd
          });
          const data = await response.json();
          if (!response.ok || data.error) throw new Error(data.error?.message || 'Upload failed');
          uploadedImages.push(data);

          const progressBar = uploadPreview.find(`.preview-item:eq(${i}) .progress-bar`);
          progressBar.css({ width: '100%', 'background-color': '#28a745' });
        } catch (err) {
          console.error('Cloudinary upload error:', err);
          throw err;
        }
      }
    }

    // Build Rails payload
    const railsFormData = new FormData();
    const noteId = form.data('id');
    if (noteId) railsFormData.append('property_note[id]', noteId);
    railsFormData.append('property_note[visited_by_id]',        form.find('#property_note_visited_by_id').val());
    railsFormData.append('property_note[property_visited_date]', form.find('#property_note_property_visited_date').val());
    railsFormData.append('property_note[description]',          form.find('#property_note_description').val());
    railsFormData.append('property_note[window]',               form.find('#property_note_window').val());
    railsFormData.append('property_note[roof]',                 form.find('#property_note_roof').val());
    railsFormData.append('property_note[vacancy]',              form.find('#property_note_vacancy').val());
    railsFormData.append('property_note[garage]',               form.find('#property_note_garage').val());
    railsFormData.append('authenticity_token',                  form.find('input[name="authenticity_token"]').val());
    uploadedImages.forEach(img => railsFormData.append('property_note[cloudinary_ids][]', JSON.stringify(img)));

    const url = form.data('url');
    $.ajax({
      url: url,
      method: 'POST',
      data: railsFormData,
      processData: false,
      contentType: false,
      dataType: 'json',
      success: function(response) {
        if (response.success) {
          form.closest('.modal').modal('hide');
          toastr.success(response.message || 'Note saved successfully');
          setTimeout(() => window.location.reload(), 3000);
        }
      },
      error: function(xhr) {
        let errors;
        try { errors = xhr.responseJSON.errors; } catch(e) { errors = ['An error occurred while saving']; }
        form.find('.form-errors').removeClass('d-none').html(errors.join('<br>'));
      },
      complete: function() {
        btn.prop('disabled', false).text(form.data('id') ? 'Update' : 'Save');
      }
    });
  } catch (error) {
    uploadStatus.attr('class', 'alert alert-danger').text(`Upload failed: ${error.message}`);
    toastr.error('Error uploading images. Please try again.');
    btn.prop('disabled', false).text(form.data('id') ? 'Update' : 'Save');
  }
};

function initializePropertyNoteImageUpload() {
  // Accumulate files across multiple open-dialog clicks (no replace)
  $(document).off('change.noteImages', 'input[name="property_note[images][]"]')
    .on('change.noteImages', 'input[name="property_note[images][]"]', function(e) {
      const newFiles = Array.from(e.target.files);
      const form = $(this).closest('.property-note-form');
      const formEl = form[0];
      if (!formEl || !newFiles.length) return;

      // Reset the file input immediately so the same file can be re-added after removal
      e.target.value = '';

      // Merge: skip exact duplicates (same name + size)
      const existing = getFiles(formEl);
      const merged = [...existing];
      newFiles.forEach(file => {
        const isDupe = merged.some(f => f.name === file.name && f.size === file.size);
        if (!isDupe) merged.push(file);
      });

      if (merged.length > 50) {
        toastr.error('You can only upload up to 50 images at a time');
        return;
      }

      setFiles(formEl, merged);
      renderPreview(form, merged);
    });

  // Remove individual file from the accumulated list
  $(document).off('click.noteImageRemove', '.remove-preview-image')
    .on('click.noteImageRemove', '.remove-preview-image', function(e) {
      e.stopPropagation();
      const form = $(this).closest('.property-note-form');
      const formEl = form[0];
      if (!formEl) return;
      const index = parseInt($(this).data('index'), 10);
      const files = getFiles(formEl);
      files.splice(index, 1);
      setFiles(formEl, files);
      renderPreview(form, files);
    });
}

document.addEventListener('turbolinks:load', initializePropertyNoteImageUpload);
